export const SESSION_CONTEXT_TYPE = 'session';
export const FORM_CONTEXT_TYPE = 'form';
